import React, { useState, useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Rating,
  Snackbar,
} from "@mui/material";

const DisplaySubRecipes = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [formData, setFormData] = useState({});
  const [alternative_methods, setAlternative_methods] = useState(null);
  const [choice, setChoice] = useState(null);
  const [cooking_tips, setCooking_tips] = useState(null);
  const [equiprecipe_title, setEquiprecipe_title] = useState(null);
  const [expert_tips, setExpert_tips] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [ingredient_name, setIngredient_name] = useState(null);
  const [instructions, setInstructions] = useState(null);
  const [nutri_facts, setNutri_facts] = useState(null);
  //  const [alternative_methods, setAlternative_methods] = useState(null);

  useEffect(() => {
    fetchRecipes();
  }, []);

  const fetchRecipes = async () => {
    try {
      const response = await fetch(`${API_URL}/subrecipe/getall`); // Replace with your backend endpoint
      const data = await response.json();
      console.log(data);
      setRecipes(data?.results);
      setAlternative_methods(data.results[0].alternative_methods);
      setChoice(data.results[0].choice);
      setCooking_tips(data.results[0].cooking_tips);
      setEquiprecipe_title(data.results[0].equiprecipe_title);
      setExpert_tips(data.results[0].expert_tips);
      setFaqs(data.results[0].faqs);
      setIngredient_name(data.results[0].ingredient_name);
      setInstructions(data.results[0].instructions);
      setNutri_facts(data.results[0].nutri_facts);

      console.log(data.results);
      console.log(data.results.choice);
    } catch (error) {
      console.error("Error fetching recipes:", error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDetailsDialog = (recipe) => {
    setSelectedRecipe(recipe);
    // setChoice(recipe);

    setOpenDetailsDialog(true);
  };
  console.log(selectedRecipe);
  const handleOpenEditDialog = (recipe) => {
    setSelectedRecipe(recipe);
    // setChoice(recipe);
    setFormData({ ...recipe });
    setOpenEditDialog(true);
  };

  const handleOpenDeleteDialog = (recipe) => {
    setSelectedRecipe(recipe);
    // setChoice(recipe);
    setOpenDeleteDialog(true);
  };

  const handleCloseDialogs = () => {
    setOpenDetailsDialog(false);
    setOpenEditDialog(false);
    setOpenDeleteDialog(false);
    setSelectedRecipe(null);
    // setChoice(null);
    setFormData({});
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`/api/recipes/${selectedRecipe.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update recipe");
      }

      const updatedRecipe = await response.json();
      setRecipes((prev) =>
        prev.map((recipe) =>
          recipe.id === updatedRecipe.id ? updatedRecipe : recipe
        )
      );
      console.log("Recipe updated:", updatedRecipe);
    } catch (error) {
      console.error("Error updating recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleDeleteSubmit = async () => {
    try {
      const response = await fetch(`/api/recipes/${selectedRecipe.id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Failed to delete recipe");
      }

      setRecipes((prev) =>
        prev.filter((recipe) => recipe.id !== selectedRecipe.id)
      );
      console.log("Recipe deleted:", selectedRecipe);
    } catch (error) {
      console.error("Error deleting recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell> subRecipes ID</TableCell>
              <TableCell>title Id</TableCell>
              <TableCell>Summary</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recipes
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((recipe) => (
                <TableRow key={recipe?.subRecipes_id}>
                  <TableCell>{recipe?.subRecipes_id}</TableCell>
                  <TableCell>{recipe?.title_id}</TableCell>
                  <TableCell sx={{ width: "50%" }}>{recipe?.summary}</TableCell>

                  <TableCell
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      //   justifyContent: "space-evenly",
                      gap: 4,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleOpenEditDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleOpenDeleteDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={() => handleOpenDetailsDialog(recipe)}
                    >
                      See Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={recipes.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* See Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Recipe Details</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            <b>subRecipes ID:</b> {selectedRecipe?.SubRecipes_id}
          </Typography>
          <Typography variant="body1">
            <b>User Id:</b> {selectedRecipe?.user_id}
          </Typography>
          <Typography variant="body1">
            <b>Title Id:</b> {selectedRecipe?.title_id}
          </Typography>
          <Typography variant="body1">
            <b>Category Id:</b> {selectedRecipe?.category_id}
          </Typography>
          <Typography variant="body1">
            <b>Prep time:</b> {selectedRecipe?.prep_time}
          </Typography>
          <Typography variant="body1">
            <b>Cook time:</b> {selectedRecipe?.cook_time}
          </Typography>
          <Typography variant="body1">
            <b>Number servings:</b> {selectedRecipe?.num_servings}
          </Typography>
          <Box variant="body1">
            <b>Ingredient Name:</b>{" "}
            {selectedRecipe && selectedRecipe?.ingredient_name?.length > 0 && (
              <List>
                {selectedRecipe?.ingredient_name?.map((ingredient) => (
                  <div key={ingredient.number}>
                    <Typography variant="h6" fontWeight="bold">
                      {ingredient.number}. {ingredient.title}
                    </Typography>
                    {ingredient?.details?.map((detail, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={`✔️ ${detail}`} />
                      </ListItem>
                    ))}
                  </div>
                ))}
              </List>
            )}
          </Box>

          <Box variant="body1">
            <b sx={{ color: "red" }}>nutri_facts:</b>{" "}
            <TableContainer
              // ref={(el) => (refs.current.nutri_facts = el)}
              component={Paper}
              sx={{ marginTop: 3, backgroundColor: "	#F0F8FF", mb: 2 }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: "black", fontSize: "18px" }}>
                      <strong>No.</strong>
                    </TableCell>
                    <TableCell sx={{ color: "black", fontSize: "18px" }}>
                      <strong>Nutrient</strong>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ color: "black", fontSize: "18px" }}
                    >
                      <strong>Content</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>

                {selectedRecipe && selectedRecipe?.nutri_facts?.length > 0 && (
                  <TableBody>
                    {selectedRecipe?.nutri_facts?.map((item, index) => (
                      <TableRow key={item.index}>
                        <TableCell sx={{ color: "black", fontSize: "18px" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ color: "black", fontSize: "18px" }}>
                          {item.nutrient}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ color: "black", fontSize: "18px" }}
                        >
                          {item.content}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
          <Box variant="body1">
            <b>Equipment title:</b>{" "}
            {selectedRecipe?.equiprecipe_title &&
              Array.isArray(selectedRecipe?.equiprecipe_title) && (
                <List>
                  {selectedRecipe?.equiprecipe_title?.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={`✅ ${item}`} />
                    </ListItem>
                  ))}
                </List>
              )}
          </Box>
          <Typography variant="body1">
            <b>Summary:</b> {selectedRecipe?.summary}
          </Typography>
          <Box variant="body1">
            <b>Instructions:</b>
            {selectedRecipe && selectedRecipe?.instructions?.length > 0 && (
              <Box>
                {selectedRecipe?.instructions?.map((step, index) => (
                  <div
                    key={index}
                    className="instruction-item"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginBottom: "1rem",
                    }}
                  >
                    {/* List Order Number */}
                    <div
                      className="step-number"
                      style={{
                        marginRight: "1rem",
                        fontWeight: "bold",
                        fontSize: "1.25rem",
                      }}
                    >
                      {index + 1}.
                    </div>

                    {/* Instruction Content */}
                    <div className="instruction-content">
                      <div
                        className="instruction-title"
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.25rem",
                        }}
                      >
                        {step.title}
                      </div>
                      <div className="instruction-details">
                        {step.details.map((detail, i) => (
                          <p key={i} style={{ margin: "0.25rem 0" }}>
                            📝 {detail}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </Box>
            )}
          </Box>
          <Box variant="body1">
            <b>Alternative methods:</b>{" "}
            {selectedRecipe?.alternative_methods &&
              Array.isArray(selectedRecipe?.alternative_methods) && (
                <List>
                  {selectedRecipe?.alternative_methods?.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={`✅ ${item}`} />
                    </ListItem>
                  ))}
                </List>
              )}
          </Box>
          <Box variant="body1">
            <b>Cooking tips:</b>{" "}
            {selectedRecipe?.cooking_tips &&
              Array.isArray(selectedRecipe?.cooking_tips) && (
                <List>
                  {selectedRecipe?.cooking_tips?.map((item, index) => {
                    const splitIndex = item.indexOf(":"); // Find the first occurrence of '-'

                    // Bold the text before the ':' and keep the rest as is
                    const boldText =
                      splitIndex !== -1
                        ? item.slice(0, splitIndex).trim()
                        : item;
                    const remainingText =
                      splitIndex !== -1 ? item.slice(splitIndex).trim() : "";

                    return (
                      <ListItem key={index}>
                        <ListItemText
                          primary={
                            <Typography component="span">
                              <strong>{`👉🏼 ${boldText}`}</strong>
                              {remainingText}
                            </Typography>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              )}
          </Box>
          <Box variant="body1">
            <b>Expert tips:</b>{" "}
            {selectedRecipe?.expert_tips &&
              Array.isArray(selectedRecipe?.expert_tips) && (
                <List sx={{ listStyle: "none", padding: 0 }}>
                  {selectedRecipe?.expert_tips?.map((item, index) => {
                    const splitIndex = item.indexOf(":"); // Find the first occurrence of '-'

                    // Bold the text before the '-' and keep the rest as is
                    const boldText =
                      splitIndex !== -1
                        ? item.slice(0, splitIndex).trim()
                        : item;
                    const remainingText =
                      splitIndex !== -1 ? item.slice(splitIndex).trim() : "";

                    return (
                      <ListItem key={index} sx={{ paddingLeft: 0 }}>
                        {/* Add DoneIcon in front */}
                        <ListItemIcon sx={{ minWidth: 30, marginRight: 0 }}>
                          <CheckCircleIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Typography component="span">
                              <strong>{` ${boldText}`}</strong>
                              {remainingText}
                            </Typography>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              )}
          </Box>
          <Box variant="body1">
            <b>Frequently Asked Questions:</b>
            {selectedRecipe && selectedRecipe?.faqs?.length > 0 && (
              <Box>
                {selectedRecipe?.faqs?.map((faq, index) => (
                  <Accordion key={index}>
                    <AccordionSummary
                      sx={{ height: "4px" }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                    >
                      <Typography sx={{ color: "#0000CD", fontSize: "18px" }}>
                        {faq.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>{faq.answer}</Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            )}
          </Box>
          <Typography variant="body1">
            <b>Tags:</b> {selectedRecipe?.tags}
          </Typography>
          <Box variant="body1">
            <b>Choice:</b>
            {/* <List>
                          {choice?.map((item, index) => {
                            const splitIndex = item.indexOf(":"); // Find the first occurrence of '-'

                            // Bold the text before the '-' and keep the rest as is
                            const boldText =
                              splitIndex !== -1
                                ? item.slice(0, splitIndex).trim()
                                : item;
                            const remainingText =
                              splitIndex !== -1
                                ? item.slice(splitIndex).trim()
                                : "";

                            return (
                              <ListItem key={index}>
                                <ListItemText
                                  primary={
                                    <Typography component="span">
                                      <Typography>{`❣️ ${boldText}`}</Typography>
                                      {remainingText}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                     
                        </List> */}
            {selectedRecipe?.choice &&
              Array.isArray(selectedRecipe?.choice) && (
                <List>
                  {selectedRecipe?.choice.map((item, index) => {
                    const splitIndex = item.indexOf(":"); // Find the first occurrence of '-'

                    // Bold the text before the '-' and keep the rest as is
                    const boldText =
                      splitIndex !== -1
                        ? item.slice(0, splitIndex).trim()
                        : item;
                    const remainingText =
                      splitIndex !== -1 ? item.slice(splitIndex).trim() : "";

                    return (
                      <ListItem key={index}>
                        <ListItemText
                          primary={
                            <Typography component="span">
                              <strong>{`❣️ ${boldText}`}</strong>
                              {remainingText}
                            </Typography>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              )}
          </Box>
          <Typography variant="body1">
            <b>Created_at:</b> {selectedRecipe?.created_at}
          </Typography>
          <Typography variant="body1">
            <b>Updated_at:</b> {selectedRecipe?.updated_at}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={openEditDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Edit Recipe</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            name="title_name"
            value={formData.title_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Description"
            name="short_description"
            value={formData.short_description || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete the recipe{" "}
          <b>{selectedRecipe?.title_name}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteSubmit} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplaySubRecipes;
